import { Avatar, Box, Button, Input, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { GLItemDTO, GLItemKind, GLItemKinds, GLItemStatus, GLItemStatuses } from "../../../DTO/GLItemDTO";
import InputB from "../../../components/InputB/InputB";
import { use, useEffect, useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DisplayDateFromString, DisplayPHPDate, DisplayTimeFromString } from "../../../services/DateTime";
import mainservice from "../../../services/MainService";
import { Alarm, ArrowRight, Delete, ZoomIn, ZoomOut } from "@mui/icons-material";
import { TagSelector } from "../tags/TagSelector";
import { TagDTO, TagType } from "../../DTO/TagDTO";
import { X } from "react-feather";
import InlineMenu from "../../elements/InlineMenu";

enum Status {
    idle,
    saving,
    deleted,
}

export default function LogChatMsg({
    item,
    saveStart,
    saveCB,
    onClickDetail,
    className = '',
    marked = false,
}: {
    item: GLItemDTO,
    saveStart?: () => void,
    saveCB: () => void,
    onClickDetail?: (id: number) => void,
    className?: string,
    marked?: boolean,
}) {
    //const [content, setContent] = useState(item.content)
    const [glitem, setglitem] = useState(item)
    const [status, setStatus] = useState(Status.idle)
    const [minMax, setMinMax] = useState<'normalMe'|'expandedMe'>('normalMe')
    const [localClassName, setLocalClassName] = useState(className)
    const [localMarked, setLocalMarked] = useState(marked)
    const nameWidth = '300px'
    async function save(val: string) {
        if (saveStart) { saveStart() }
        glitem.content = val
        await glitem.save(true)
        saveCB()
    }
    useEffect(() => {
        setLocalClassName(className)
    }, [className])
    useEffect(() => {
        setLocalMarked(marked)
    }, [marked])
    useEffect(() => {
        setglitem(item)
    }, [item])
    if (status === Status.deleted) {
        return null
    }
    return <Stack
        className={`${minMax} LogChatMsg ${localClassName}`}
        spacing={2}
        direction={'column'}
        sx={{
            borderRadius: 1,
            padding: 1,
            border: localMarked ? '2px solid black' : '1px solid grey',
        }}
    >
        <Stack
            direction='row'
            spacing={1}
            sx={{
                justifyContent: 'space-between',
                alignItems: 'start',
            }}
        >
            {
                glitem.created &&
                <Stack
                    direction='row'
                    spacing={1}
                    sx={{
                        paddingBottom: 1,
                        alignItems: 'start',
                    }}
                >
                    {
                        glitem.created &&
                        <Stack
                            title="Erstellt am"
                            sx={{
                                paddingTop: 1,
                            }}
                        >
                            <Box>
                                {DisplayDateFromString(glitem.created || '')}
                            </Box>
                            <Box>
                                {DisplayTimeFromString(glitem.created || '')}
                            </Box>
                            {
                                glitem.printReminderDate() &&
                                <Box
                                    className="hidden-when-max"
                                >
                                    <Alarm
                                        color={glitem.reminderExpired() ? 'error' : 'inherit'}
                                    />
                                    {glitem.printReminderDate()}
                                </Box>
                            }
                        </Stack>
                    }
                    {
                        glitem.person &&
                        <Stack
                            sx={{
                                alignItems: 'stretch',
                            }}
                        >

                            {
                                glitem.person &&
                                <Box
                                    title={glitem.person.getDisplayName()}
                                    sx={{
                                        width: nameWidth,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    <Button
                                        sx={{
                                            width: '100%',
                                            justifyContent: 'left',
                                            textAlign: 'left',
                                        }}
                                        onClick={() => {
                                            mainservice.navTo([['view', 'spPersonEdit'], ['id', glitem.person?.id || -1]])
                                        }}
                                    >
                                        {glitem.person.getDisplayName()}
                                    </Button>
                                </Box>
                            }
                            {
                                glitem.person?.customerName &&
                                <Box
                                    title={glitem.person.customerName}
                                    sx={{
                                        width: nameWidth,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    <Button
                                        sx={{
                                            width: '100%',
                                            justifyContent: 'left',
                                            textAlign: 'left',
                                        }}
                                        onClick={() => {
                                            mainservice.navTo([['view', 'spCustomerEdit'], ['id', glitem.person?.customerId || -1]])
                                        }}
                                    >
                                        {glitem.person.customerName}
                                    </Button>
                                </Box>
                            }
                        </Stack>
                    }
                </Stack>
            }
            <Stack
                direction='row'
                sx={{
                    flexGrow: 2,
                    paddingTop: 1,
                    minWidth: '150px',
                }}
            >
                <InputB
                    value={glitem.headline}
                    className="w100"
                    returnVal={async (value: string) => {
                        glitem.headline = value
                        await glitem.save()
                    }}
                />
            </Stack>
            <Stack
                direction='row'
                spacing={1}
                sx={{
                    alignItems: 'start',
                    paddingTop: 1,
                }}
            >
                {
                    glitem.kind === GLItemKind.marketing &&
                    <>
                        <InputB
                            title="Potenzial [€]"
                            className="hidden-when-max"
                            value={`${glitem.revenue_potential || '-'}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setRevenuePotential(parseFloat(value))
                                setStatus(Status.idle)
                            }}
                            width="100px"
                        />
                        <InputB
                            title="Wahrscheinlichkeit [%]"
                            className="hidden-when-max"
                            value={`${glitem.revenue_probability || '-'}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setRevenueProbability(parseFloat(value))
                                setStatus(Status.idle)
                            }}
                            width="50px"
                        />
                    </>
                }
                <Box
                    title={glitem.author?.name || ''}
                >
                    <Avatar
                        sx={{ bgcolor: item.getAuthorColor() }}
                    >{glitem.getAuthorInitials()}</Avatar>
                </Box>
                {
                    glitem.kind !== undefined && GLItemStatuses[glitem.kind].length > 0 &&
                    <Select
                        value={glitem.status}
                        onChange={async (e) => {
                            setStatus(Status.saving)
                            glitem.status = Number(e.target.value)
                            if (glitem.id === -1) {
                                setTimeout(async () => {
                                    setStatus(Status.idle)
                                }, 500);
                            } else {
                                await glitem.save()
                                setStatus(Status.idle)
                            }
                        }}
                        label="Status"
                    >
                        {
                            GLItemStatuses[glitem.kind].map(s => {
                                return <MenuItem value={`${s.status}`} key={`message-${glitem.id}-status-${s.status}`}>
                                    {s.name}
                                </MenuItem>
                            })
                        }
                    </Select>
                }
                {
                    (!glitem.parentId || glitem.parentId === -1)  &&
                    <Select
                        value={glitem.kind}
                        onChange={async (e) => {
                            setStatus(Status.saving)
                            glitem.status = GLItemStatus.generic
                            glitem.kind = Number(e.target.value)
                            if (glitem.id === -1) {
                                setTimeout(async () => {
                                    setStatus(Status.idle)
                                }, 500);
                            } else {
                                await glitem.save()
                                setStatus(Status.idle)
                            }
                        }}
                        label="Art"
                    >
                        {
                            GLItemKinds.map(k => {
                                if (glitem.showKindOption(k.id) === false) { return null }
                                return <MenuItem value={`${k.id}`} key={`message-${glitem.id}-kindId-${k.id}`}>
                                    {k.name}
                                </MenuItem>
                            })
                        }
                    </Select>
                }
                {
                    onClickDetail &&
                    <Button
                        variant="contained"
                        endIcon={<ArrowRight />}
                        onClick={() => {
                            onClickDetail!(glitem.id)
                        }}
                        sx={{
                            width: '140px',
                        }}
                    >
                        Details { glitem.childrenCount > -1 ? ` (${glitem.childrenCount})` : ''}
                    </Button>
                }
                {
                    minMax === 'normalMe' ? <Button
                        className="child-min-max-btn"
                        onClick={() => setMinMax('expandedMe')}
                    >
                        <ZoomIn />
                    </Button> : <Button
                        className="child-min-max-btn"
                        onClick={() => setMinMax('normalMe')}
                    >
                        <ZoomOut />
                    </Button>
                }
                
                <InlineMenu
                    title={<MoreVertIcon />}
                    options={
                        [
                            {
                                title: 'Löschen',
                                icon: <Delete />,
                                show: true,
                                onClick: async () => {
                                    const deleted = await glitem.delete()
                                    if (deleted) {
                                        setStatus(Status.deleted)
                                    }
                                },
                                disabled: glitem.showDelete()=== false,
                            },
                        ]
                    }
                />
            </Stack>
        </Stack>
        {
            onClickDetail &&
            <Stack
                className="shrink-when-min reminder-row"
                direction="row"
                spacing={1}
                sx={{
                    alignItems: 'center',
                }}
            >

                <Alarm
                    className="hidden-when-min"
                    color={glitem.reminderExpired() ? 'error' : 'inherit'}
                />
                <InputB
                    value={DisplayPHPDate(new Date(glitem.reminderDate || ''))}
                    returnVal={async (value: string) => {
                        /*
                        setStatus(Status.loading)
                        buildingBlocksDTO.minDate = value
                        setGlobMinDate(new Date(value))
                        buildingBlocksDTO.setElementKindPage(0, objectKind, publishKind).then(() => {
                        setStatus(Status.standard);
                        });
                        */
                        await glitem.saveReminderDate(value)
                    }}
                    noGrouping={true}
                    type='date'
                />
                <Button
                    variant="outlined"
                    onClick={async () => {
                        setStatus(Status.saving)
                        await glitem.saveReminderDate('')
                        setStatus(Status.idle)
                    }}
                >
                    <X />
                </Button>
            </Stack>
        }
        {
            glitem.person &&
            <Stack
                className="shrink-when-min"
                direction="row"
                spacing={1}      
            >
                { // Tags
                    [
                    {
                        kind: 'FUNKTIONHOMOGEN',
                        mode: 'single'
                    },
                    {
                        kind: 'ABTEILUNGHOMOGEN',
                        mode: 'single'
                    },
                    {
                        kind: 'marketingRole',
                        mode: 'list'
                    },
                    {
                        kind: 'groupInfo',
                        mode: 'list'
                    },
                    {
                        kind: 'sales_origin',
                        mode: 'single'
                    },
                    ].map((t, index) => <Box
                        key={`person-tag-selector-${item.id}-${glitem.person?.id}-${t.kind}`}
                    >
                    <TagSelector
                        parentId={item.id}
                        kind={t.kind as TagType}
                        mode={t.mode as 'list' | 'single'}
                        selectedTags={glitem.person!.getTagsByKind(t.kind as TagType, 'tag')}
                        selectTag={async (tag: TagDTO, single: boolean) => {
                          await glitem.person!.setTag(tag, true);
                        }}
                        unsetTag={async (tag: TagDTO) => {
                          await glitem.person!.unsetTag(tag);
                        }}
                        readMode={false}
                    />
                    </Box>
                    )
                }
            </Stack>
        }
        {
            glitem.kind === GLItemKind.marketing &&
            <>
               
                <Stack
                    className="hidden-when-min"
                    direction='row'
                    spacing={2}
                >
                    <Stack
                        direction='column'
                        spacing={1}
                    >
                        <label>Potenzial [€]:</label>
                        <InputB
                            value={`${glitem.revenue_potential || '-'}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setRevenuePotential(parseFloat(value))
                                setStatus(Status.idle)
                            }}
                        />
                    </Stack>
                    <Stack
                        direction='column'
                        spacing={1}
                    >
                        <label>Wahrscheinlichkeit [%]:</label>
                        <InputB
                            value={`${glitem.revenue_probability || '-'}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setRevenueProbability(parseFloat(value))
                                setStatus(Status.idle)
                            }}
                        />
                    </Stack>
                    <Stack
                        direction='column'
                        spacing={1}
                    >
                        <label>gewichtetes Potenzial [€]:</label>
                        <Input disabled value={`${glitem.weighted_revenue || '-'}`} />
                    </Stack>
                    
                        
                    <Stack
                        className="shrink-when-min"
                        direction='column'
                        spacing={1}
                        sx={{
                            paddingBottom: 2,
                        }}
                    >
                        <label>Quartal:</label>
                        <Stack
                            direction='row'
                            spacing={1}
                        >
                            <Select
                                value={glitem.getQuarter().quarter}
                                onChange={async (e: SelectChangeEvent<string>) => {
                                    const {
                                        target: { value },
                                    } = e
                                    setStatus(Status.saving)
                                    console.log('value ey!', value, e)
                                    await glitem.setQuarter(value, glitem.getQuarter().year)
                                    setStatus(Status.idle)
                                }}
                            >
                                {
                                    glitem.getQuarters().map(q => {
                                        return <MenuItem value={`${q.id}`} key={`message-${glitem.id}-quarter-${q.id}`}>
                                            {q.id}
                                        </MenuItem>
                                    })
                                }
                            </Select>
                            <InputB
                                value={`${glitem.getQuarter().year}`}
                                returnVal={async (value: string) => {
                                    setStatus(Status.saving)
                                    await glitem.setQuarter(glitem.getQuarter().quarter, parseInt(value))
                                    setStatus(Status.idle)
                                }}
                            />
                            <Button
                                variant="outlined"
                                onClick={async () => {
                                    setStatus(Status.saving)
                                    await glitem.setQuarter('none', new Date().getFullYear())
                                    setStatus(Status.idle)
                                }}
                            >
                                <X />
                            </Button>
                        </Stack>
                        
                    </Stack>
                </Stack>
            </>
        }
        <InputB
            className="shrink-when-min"
            returnVal={save}
            type={'wysiwyg'}
            value={glitem.content}
        />
    </Stack>
}
